'use strict';

import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import carouselTemplate from './carousel.directive.html';
import './carousel.directive.scss';

export default angular
  .module('maestro.directives.components.carousel', [])

  .directive('carousel', function() {
    return {
      restrict: 'E',
      replace: true,
      template: carouselTemplate,
      scope: {
        media: '='
      },
      controller: ($scope, $element, $log, $timeout) => {
        let swiper;

        angular.extend($scope, {
          isImage: isImage,
          isVideo: isVideo,
          reinitCarousel: reinitCarousel
        });

        init();

        function init() {
          swiper = new Swiper($($element)[0], {
            pagination: {
              el: $element.find('.swiper-pagination')[0],
            },
            autoHeight: true,
            centeredSlides: true,
            modules: [Pagination],
          });

          $scope.$on('$destroy', () => {
            if (swiper && swiper.destroy) {
              try {
                swiper.destroy();
              } catch (e) {
                $log.error(e);
              }
            }
            swiper = void 0;
          });

          $scope.$watch('media', () => {
            if ($scope.media && swiper) {
              $timeout(() => {
                swiper.update();
              }, 100);
            }
          }, true);
        }

        function reinitCarousel() {
          swiper.update();
        }

        function isImage(mediaObject) {
          return mediaObject && (mediaObject.type != null && mediaObject.type === 2) || (mediaObject.contentType && mediaObject.contentType.startsWith('image'));
        }

        function isVideo(mediaObject) {
          return mediaObject && (mediaObject.type != null && mediaObject.type === 1) || (mediaObject.contentType && mediaObject.contentType.startsWith('video'));
        }
      }
    };
  })

  .name;
